// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__VoYiJ","menu__lista":"Menu_menu__lista__MNs6C","menu__item":"Menu_menu__item__7-+C7"};